<ng-container *ngIf="apps$ | async as apps">
  <ng-container *ngIf="!isLoading">
    <span class="description">{{ descriptionTranslationId | translate }}</span>
    <ng-container *ngIf="appOptions$ | async">
      <inventory-ui-item-search-single-select-filter
        [config]="{
          partnerId: automation.namespace,
          marketId: automation.marketId,
          filters: listActivatableItemsFilterForAppType,
          customDropdownItems: [
            {
              appId: ANY_PRODUCT,
              name: 'AUTOMATIONS.EDITOR.TRIGGERS.PRODUCT_ACTIVATION.ANY_PRODUCT' | translate
            }
          ]
        }"
        [selectedItem]="{
          appId: selectedAppId$ | async
        }"
        (selectionChange)="itemSelectionChanged($event)"
      ></inventory-ui-item-search-single-select-filter>
    </ng-container>
    <ng-container *ngIf="selectedAppId$ | async">
      <ng-container *ngIf="{ editions: editionOptions$ | async, addons: addonOptions$ | async } as options">
        <ng-container *ngIf="options.editions?.length > 1 || options.addons?.length > 1">
          <EXP__glxy-wrap>
            <mat-form-field>
              <mat-label>
                {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PRODUCT_ACTIVATION.SELECT_PRODUCT_TYPE' | translate }}
              </mat-label>
              <mat-select [formControl]="editionsOrAddonsControl">
                <ng-container *ngFor="let o of editionsOrAddonsOptions">
                  <mat-option [value]="o.value" [disabled]="o.value === ANY_ADDON && disableAddonSelection">
                    {{ o.label | translate }}
                  </mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </EXP__glxy-wrap>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="editionsOrAddonsControl.value === ANY_EDITION && editionOptions$ | async as editions">
        <ng-container *ngIf="editions.length > 0">
          <EXP__glxy-wrap>
            <mat-form-field>
              <mat-label>
                {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PRODUCT_ACTIVATION.SELECT_EDITION' | translate }}
              </mat-label>
              <mat-select [formControl]="editionControl">
                <mat-option *ngFor="let o of editions" [value]="o.value">
                  {{ o.label | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </EXP__glxy-wrap>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="editionsOrAddonsControl.value === ANY_EDITION && includeTrialSelection">
        <ng-container *ngIf="trialOptions$ | async as trialOptions">
          <ng-container *ngIf="trialOptions.length > 0">
            <EXP__glxy-wrap>
              <mat-form-field>
                <mat-label>
                  {{ 'AUTOMATIONS.EDITOR.TRIGGERS.PRODUCT_ACTIVATION.SELECT_TRIAL_OPTION' | translate }}
                </mat-label>
                <mat-select [formControl]="trialControl">
                  <mat-option *ngFor="let o of trialOptions" [value]="o.value">
                    {{ o.label | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </EXP__glxy-wrap>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="editionsOrAddonsControl.value === ANY_ADDON && addonOptions$ | async as addons">
        <ng-container *ngIf="addons.length > 0">
          <inventory-ui-item-search-single-select-filter
            [config]="{
              partnerId: automation.namespace,
              marketId: automation.marketId,
              filters: listActivatableItemsFilterForAddonType$ | async,
              customDropdownItems: [
                {
                  addonId: ANY_ADDON,
                  name: 'AUTOMATIONS.EDITOR.TRIGGERS.PRODUCT_ACTIVATION.ANY_ADDON' | translate
                }
              ]
            }"
            [selectedItem]="{
              addonId: selectedAddonId$ | async
            }"
            (selectionChange)="addonSelectionChanged($event)"
          ></inventory-ui-item-search-single-select-filter>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<ng-container *ngIf="isLoading">
  <div class="side-drawer-shimmer-container">
    <span class="title stencil-shimmer"></span>
    <span class="selector stencil-shimmer"></span>
  </div>
</ng-container>
